import { render, staticRenderFns } from "./legal.vue?vue&type=template&id=71bf24c2&"
import script from "./legal.vue?vue&type=script&lang=js&"
export * from "./legal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports